


























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'SearchField',
})
export default class SearchField extends Vue {
    @Prop() private isSearching: boolean;
    @Prop() private searchQuery: string;

    get searchQueryCopy() {
        return this.searchQuery;
    }

    // noinspection JSUnusedGlobalSymbols
    set searchQueryCopy(value: string) {
        this.$emit('updateSearchQuery', value);
    }

    private clearSearch() {
        this.$emit('clearSearch');
    }
}
